/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {useCallback, useContext, useState} from "react";
import {Form, Checkbox, Row, Col} from "antd";
import {Title} from "./Common";
import MapPropsContext from "../MapPropsContext";


export const OPTIONS = [
//  {value: "05,06", label: "2G", iconCode: '2g-out'},
  {value: "11", label: "SKT 3.5G", iconCode: '5g-sk-in'},
  {value: "21", label: "KT 3.5G", iconCode: '5g-kt-in'},
  {value: "31", label: "LGU+ 3.5G", iconCode: '5g-lg-in'},
   {value: "12", label: "SKT 28G", iconCode: '5g-sk-out'},
  {value: "22", label: "KT 28G", iconCode: '5g-kt-out'},
  {value: "32", label: "LGU+ 28G", iconCode: '5g-lg-out'},
];


function WidgetImpCheckServiceCode() {
  const {widgetState, onChangeWidgetState, iconDict} = useContext(MapPropsContext);
  const {service_code_list} = widgetState;
  const [state, setState] = useState({
    indeterminate: (service_code_list.length < OPTIONS.length),
    checkAll: (service_code_list.length === OPTIONS.length),
  });

  const onCheckAllChange = useCallback(({ target: { checked } }) => {
    setState({
      indeterminate: false,
      checkAll: checked,
    });
    onChangeWidgetState({
      target: {
        name: 'service_code_list',
        value: !checked ? [] : OPTIONS.map(({ value }) => value),
      }}
    );
  }, []);

  const onChange = useCallback((checkedValues) => {
    setState({
      indeterminate: !!checkedValues.length && checkedValues.length < OPTIONS.length,
      checkAll: (checkedValues.length === OPTIONS.length),
    });

    onChangeWidgetState({
      target: {
        name: 'service_code_list',
        value: checkedValues,
      }}
    );
  }, [onChangeWidgetState, setState]);

  const {indeterminate, checkAll} = state;

  return (
    <Form.Item>
      <Title extra={
               <Checkbox checked={checkAll} indeterminate={indeterminate} onChange={onCheckAllChange}>
                 전체 선택
               </Checkbox>
             }>
        통신사
      </Title>
      <Checkbox.Group name="service_code_list"
                      value={service_code_list}
                      onChange={onChange}
                      size={"small"}
                      style={{ width: '100%' }}>
        <Row>
          {OPTIONS.map(({value, label, iconCode}) => {
            const { data, width, height} = iconDict[iconCode] || {};
            const iconWidth = 24;
            const ratio = iconWidth / width;
            const iconHeight = Math.floor(height * ratio);
            return (
              <Col span={8} key={value}>
                <Checkbox value={value} key={label}>
                  {data && <img src={data} style={{ width: iconWidth, height: iconHeight, marginRight: 4 }} alt={""}/>}
                  {label}
                </Checkbox>
              </Col>
            );
          })}
        </Row>
      </Checkbox.Group>
      <br/>
    </Form.Item>
  );
}


export default WidgetImpCheckServiceCode;
